import usePrivateAxios from '@/common/api/usePrivateAxios';
import { LastReviewValidationSchema } from '@/common/schemas/lastReview.schema';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseUpdateMaintenanceDirectiveDiagnosticEntryLastReviewProps {
  directiveEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    LastReviewValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateMaintenanceDirectiveDiagnosticEntryLastReview = ({
  directiveEntryId,
  options,
}: UseUpdateMaintenanceDirectiveDiagnosticEntryLastReviewProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateMaintenanceDirectiveDiagnosticEntryLastReview'],
    mutationFn: (form) => {
      return privateAxios.put(`/maintenance/directive/diagnostic_entries/${directiveEntryId}`, {
        last_review_attributes: {
          state: form.state,
          description: form.description,
        },
      });
    },
    ...options
  });
}
